
export default class ComponentV3 {
    constructor(adapter, source) {
        this.ref = null
        this.client = adapter.getPlatformClient()
        this.source = source || 'platform-app'
    }

    new(ref) {
        this.ref = ref

        return this
    }

    find(filters, opts) {
        const { 
            cache = false, 
            buildttl = -1,
            locale = "en_US"
        } = opts || {}

        return new Promise((resolve, reject) => {
            let payload = {
                context: filters,
                uuid: this.uuid,
                isApp: this.xapp,
                source: this.source
            }

            let ctx = payload.context

            let offset = ctx.currentPage
            if (offset == undefined) {
                offset = 0
            }

            let limit = ctx.perPage
            if (limit == undefined || limit == -1) {
                limit = 10
            }

            let sortDesc = 1
            if (ctx.sortDesc) {
                sortDesc = -1
            }

            if (ctx.filterOn === undefined) {
                ctx.filterOn = []
            }

            let params =  {
                offset: offset,
                sortBy: ctx.sortBy,
                sortDesc: sortDesc,
                filter: ctx.filter,
                filterOn: ctx.filterOn.join(","),
                disabled: ctx.disabled,
                limit: limit,
                dateFrom: ctx.dateFrom,
                dateTo: ctx.dateTo,
                dateField: ctx.dateField
            }
            
            if (Object.keys(ctx.$adv || []).length > 0) {
                params.$adv = JSON.stringify([ctx.$adv])
            }

            if (ctx.$aggregate && ctx.$aggregate.length > 0) {
                params.$aggregate = JSON.stringify(ctx.$aggregate)
            }

            Object.keys(opts || {}).forEach(k => {
                params[`_opt_${k}`] = opts[k]
            })

            this.client.get(`/v3/system/component/${this.ref}/models`, {
                params: params,
                headers: {
                    'X-Cache': cache,
                    'X-Build-Ttl': buildttl,
                    'X-Source': this.source,
                    'Accept-Language': locale
                }
            }).then((resp) => {
                let { data = []} = resp || {}

                resolve(data)
            }).catch((err) => {
                reject(err)
            })
        })
    }

    async findOne(filter, opts) {
        const { items } = await this.find({
            $adv: filter
        }, opts)

        if (items && items.length > 0) {
            return items[0]
        }

        return null
    }

    get(uuid) {
        return new Promise((resolve, reject) => {
            this.client.get(`/v3/system/component/${this.ref}/model/${uuid}`, {
                headers: {
                    'X-Source': this.source
                }
            }).then((resp) => {
                resolve(resp.data)
            }).catch((error) => {
                reject(error)
            })
         })
    }

    // backwards compatibility
    modify(uuid, model) {
        return this.update(uuid, model)
    }

    update(uuid, model) {
        return new Promise((resolve, reject) => {
            this.client.post(`/v3/system/component/${this.ref}/model/${uuid}`, {
                data: model
            }, {
                headers: {
                    'X-Source': this.source
                }
            }).then((resp) => {
                resolve(resp.data)
            }).catch((error) => {
                reject(error)
            })
         })
    }

    concurrentUpdate(uuid, version, model) {
        return new Promise((resolve, reject) => {
            this.client.post(`/v3/system/component/${this.ref}/model/${uuid}`, {
                version: version,
                data: model
            }, {
                headers: {
                    'X-Source': this.source
                }
            }).then((resp) => {
                resolve(resp.data)
            }).catch((error) => {
                reject(error)
            })
         })
    }

    create(model) {
        return new Promise((resolve, reject) => {
            this.client.post(`/v3/system/component/${this.ref}/model`, model, {
                headers: {
                    'X-Source': this.source
                }
            }).then((resp) => {
                resolve(resp.data)
            }).catch((error) => {
                reject(error)
            })
         })
    }

    delete(uuid) {
        return new Promise((resolve, reject) => {
            this.client.delete(`/v3/system/component/${this.ref}/model/` + uuid, {
                headers: {
                    'X-Source': this.source
                }
            }).then((resp) => {
                resolve(resp.data)
            }).catch((error) => {
                reject(error)
            })
         })
    }

    aggregate(payload) {
        return new Promise((resolve, reject) => {
            this.client.post(`/v3/system/component/${this.ref}/aggregate`, payload, {
                headers: {
                    'X-Source': this.source
                }
            }).then((resp) => {
                resolve(resp.data)
            }).catch((error) => {
                reject(error)
            })
         })
    }

    settings() {
        return new Promise((resolve, reject) => {
            this.client.get("/v3/system/component/settings/" + this.ref).then((resp) => {
                resolve(resp.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    saveSettings(settings) {
        return new Promise((resolve, reject) => {
            this.client.post("/v3/system/component/settings/" + settings.general.uuid + "/" + settings.settings.version, settings).then((resp) => {
                resolve(resp.data)
            }).catch(err => {
                reject(err)
            })
        })
    }
    
    async workflow(event, input) {
        return await this.client.post("/v1/system/component/" + this.ref + "/workflow/event", {
            event,
            input
        })
    }

    async function(name, input) {
        return await this.client.post(`/v3/system/component/${this.ref}/function/${name}`, {data: input})
    }

    async all() {
        if (this.components) {
            return this.components
        }
        
        const { data } = await this.client.get("/v1/system/components")
        this.components = data

        return this.components
    }

    async setup(data) {
        return await this.client.post("/v1/system/component/create", data) 
    }

}